import React, { createContext, useContext } from "react";
import { Theme } from "../shared/types";

type ThemeContextType = {
  theme: Theme;
};

const ThemeContext = createContext<ThemeContextType>({ theme: "default" });

export const useThemeContext = () => useContext(ThemeContext); // Hook to use the context

type ThemeProviderProps = {
  theme: Theme;
  children: React.ReactNode;
};

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  theme,
  children,
}) => {
  return (
    <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>
  );
};
